<script setup lang="ts">
import useDeveloperStore from '@/stores/developerStore'

defineOptions({ name: 'CustomAvatar' })
const developerStore = useDeveloperStore()

const isInternational = window.isInternational
</script>

<template>
  <div class="custom-avatar-wrapper">
    <div v-if="developerStore.developerAvatar.avatarText" :class="['avatar-text', isInternational && 'international']">
      {{ developerStore.developerAvatar.avatarText }}
    </div>
    <img
      v-if="developerStore.developerAvatar.avatarBg"
      class="avatar-img"
      :src="developerStore.developerAvatar.avatarBg"
    />
  </div>
</template>

<style scoped lang="less">
.custom-avatar-wrapper {
  position: relative;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  background-color: v-bind('developerStore.avatarBgColor');
  .no-select();
  cursor: pointer;
  .avatar-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    max-width: 32px;
    line-height: 28px;
    white-space: nowrap;
    &.international {
      font-size: 16px;
    }
  }
  .avatar-img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
</style>
